import { render } from "./Widget12.vue?vue&type=template&id=54be9f12"
import script from "./Widget12.vue?vue&type=script&lang=ts"
export * from "./Widget12.vue?vue&type=script&lang=ts"
script.render = render

export default script